import {
  ChangeDetectionStrategy,
  Component, DoCheck,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import * as _ from "lodash";
import {VisitScheduleResourceHolderExt} from "../../../models/visit-schedule-resource-holder-ext.model";

require('./visit-schedule-agents-list.scss');
@Component({
  standalone: false,
  selector: 'app-visit-schedule-agents-list',
  templateUrl: './visit-schedule-agents-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitScheduleAgentsListComponent implements OnChanges, DoCheck {

  @Input() agents: VisitScheduleResourceHolderExt[];
  @Input() hiddenRoutesAgentIds: string[];
  @Input() agentColorMap: { [key: string]: string };
  @Output() onLockAgentChange = new EventEmitter<{ id: string, locked: boolean }>();

  @Output() onHiddenRoutesAgentIdsChange = new EventEmitter<string[]>();

  public hiddenKeys: any;

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public hoveredAgentId: string | null = null;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.agents) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
    }
    if (changes.hiddenRoutesAgentIds) {
      this.hiddenKeys = {};
      _.forEach(this.hiddenRoutesAgentIds, (selectedId) => {
        this.hiddenKeys[selectedId] = true;
      });
    }
  }

  ngDoCheck() {
    this.cdkVirtualScrollViewport?.checkViewportSize();
  }

  onToggleAllVisible() {
    let hiddenRoutesAgentIdsCopy = this.hiddenRoutesAgentIds?.length ?
      [] :
      _.map(this.agents, 'id');

    this.onHiddenRoutesAgentIdsChange.emit(hiddenRoutesAgentIdsCopy);

  }

  onToggleVisible(agentId: string, isHidden: boolean) {
    let hiddenRoutesAgentIdsCopy = [...this.hiddenRoutesAgentIds];

    if (isHidden) {
      hiddenRoutesAgentIdsCopy.push(agentId);
    } else {
      hiddenRoutesAgentIdsCopy = hiddenRoutesAgentIdsCopy.filter((id) => {
        return id !== agentId;
      })
    }

    this.onHiddenRoutesAgentIdsChange.emit(hiddenRoutesAgentIdsCopy);
  }

}
